import { Component, OnInit, NgZone, ChangeDetectorRef, OnDestroy, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@core/services/common.service';
import { interval, Subject, Subscription } from 'rxjs';
import { ToastService } from '@shared/services/toast.service';
import { OPENGATE_ERROR_MESSAGE_DEVICE_NOT_CONNECTED } from '@shared/index';
import { INVALID_BOOKING_ID } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-generate-trux-link',
  templateUrl: './generate-trux-link.component.html',
  styleUrls: ['./generate-trux-link.component.scss']
})
export class GenerateTruxLinkComponent implements OnInit, OnDestroy {
  readonly destroyRef = inject(DestroyRef);
  errorText: string = '';
  isShowAccessCode: boolean = false;
  isGateOpenOrClosed: boolean = false;
  bookingId: any;
  isHolding = false;
  progress = 0;
  parkingLotDetails: any;
  isFirstTimeHit: boolean = false;
  gateStatusError: boolean = false;
  accessCode : string = '';
  private readonly cancel$ = new Subject<void>();
  private progressSubscription: Subscription | undefined;

  constructor(
    private readonly commonService: CommonService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly zone: NgZone,
    private readonly toastService: ToastService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.bookingId = params.get('id');
      this.checkOpenGateStatus(this.bookingId, true);
    });
  }

  ngOnDestroy() {
    this.cancel$.next();
    this.cancel$.complete();
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }
  }

  checkOpenGateStatus(bookingId: any, firstTimeHit: boolean) {
    this.progress = 0;
    this.commonService.checkOpenGateStatus(bookingId)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        
        this.isFirstTimeHit = firstTimeHit;
        this.isGateOpenOrClosed = response?.data?.relay1 !== "0";
        this.parkingLotDetails = response?.data;
        this.accessCode = response?.data?.accessCode;
        this.isHolding = false;
        if(response?.data?.isError) {
          this.isGateOpenOrClosed = false;
          this.progress = 0;
          this.gateStatusError = !!response?.data?.isError;
          this.errorText = this.gateStatusError ? response?.message : '';
          if(response?.data?.isError && response?.message === OPENGATE_ERROR_MESSAGE_DEVICE_NOT_CONNECTED) {
            this.isShowAccessCode = true;
          }
        }
      },
      error: (error) => {
        this.isFirstTimeHit = firstTimeHit;
        
        this.gateStatusError = true;
        this.errorText = error?.error?.message;
        if(this.errorText === INVALID_BOOKING_ID) {
          this.router.navigate(['/gatelync-login']);
        }
      }
    });
  }

  shouldShowItemNavigators(): boolean {
    return this.parkingLotDetails?.imagePath?.length > 1;
  }
  getDotPosition() {
    const radius = 80;
    const angle = (this.progress / 100) * 360;
    const rad = (angle - 90) * (Math.PI / 180);
    const centerX = 80;
    const centerY = 80;
    const dotRadius = radius - 6;

    const x = centerX + dotRadius * Math.cos(rad) - 5;
    const y = centerY + dotRadius * Math.sin(rad) - 5;

    return {
      top: `${y}px`,
      left: `${x}px`,
    };
  }

startHold(): void {
    this.progress = 0;
    const pauseAt = 50;
    const increment = 1;
    const intervalTime = 20; 
    
    let apiResponseReceived = false;
    this.commonService.openGate(this.bookingId)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.isGateOpenOrClosed = response?.relay1 !== "0";
        apiResponseReceived = true;
        if (this.progress >= pauseAt) {
          this.completeProgressTo100(increment, intervalTime);
        }
      },
      error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message);
      }
    });
    this.zone.runOutsideAngular(() => {
      this.progressSubscription = interval(intervalTime).subscribe(() => {
        this.zone.run(() => {
          if (this.progress < pauseAt) {
            this.progress += increment;
            this.cdr.detectChanges();
          } else {
            this.progress = pauseAt;
            this.progressSubscription?.unsubscribe();
            if (apiResponseReceived) {
              this.completeProgressTo100(increment, intervalTime);
            }
          }
        });
      });
    });
  }  

  completeProgressTo100(increment: number, intervalTime: number): void {
    this.zone.runOutsideAngular(() => {
      this.progressSubscription = interval(intervalTime).subscribe(() => {
        this.zone.run(() => {
          this.progress += increment;
  
          if (this.progress >= 100) {
            this.progress = 100;
            this.progressSubscription?.unsubscribe();
  
            setTimeout(() => {
              this.progress = 0;
              this.cdr.detectChanges();
            }, 1000);
          }  
          this.cdr.detectChanges();
        });
      });
    });
  }  

  cancelHold(): void {
    this.cancel$.next();
    this.progress = 0;
    this.progressSubscription?.unsubscribe();
  }
}